import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VSelect,{attrs:{"items":_vm.expenseAmountTypes,"item-value":"id","item-text":"expenseAmountType","clearable":_vm.clearable ? _vm.clearable : false,"label":"Amount Type","rules":[_vm.requiredCheck()],"outlined":""},model:{value:(_vm.expenseAmountTypeIdValue),callback:function ($$v) {_vm.expenseAmountTypeIdValue=$$v},expression:"expenseAmountTypeIdValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }